/**
 * Backend LengthAwarePaginatorResource returns current_page as 0-based,
 * while list UIs and page request params use 1-based indexing.
 */
export function apiPageToUiPage(apiCurrentPage: number | undefined | null): number {
  return Math.max((apiCurrentPage ?? 0) + 1, 1);
}
